import collectionsApi from "@/api/collections/client";
import { Collection } from "@/api/collections/types";
import { User } from "@/api/users/types";
import { DEFAULT_PAGE_SIZE } from "@/shared/constants";
import { useInfiniteQuery } from "@tanstack/react-query";
import { flatten } from "lodash";
import { useMemo } from "react";

export interface Props {
  artist: User;
}

const useInfiniteCollectionsForArtist = ({ artist }: Props) => {
  const { data, hasNextPage, fetchNextPage } = useInfiniteQuery(
    ["artist-collections", artist.address],
    async ({ pageParam = 0 }) => {
      const collections: Collection[] =
        await collectionsApi.getCollectionsForArtist({
          artistId: artist.address!,
          page: pageParam,
          pageSize: DEFAULT_PAGE_SIZE,
        });
      return collections.map((Collection) => ({ ...Collection, artist }));
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.length < DEFAULT_PAGE_SIZE) {
          return undefined;
        }
        return allPages.length;
      },
    },
  );

  const collections = useMemo(() => {
    return data ? flatten(data.pages) : [];
  }, [data]);

  return { collections, hasNextPage, fetchNextPage };
};

export default useInfiniteCollectionsForArtist;
